var InsuranceData = {
  "product_id": 9594451886389,
  "basic_variant": 49416745484597,
  "threshold_price": 100.00,
  "basic_price": 3.00,
  "variants": [
    { name: "*3.00", price: "3.00", id: 49416745484597 },
    { name: "1.00", price: "1.00", id: 49416745517365 },
    { name: "2.01", price: "2.01", id: 49416745550133 },
    { name: "3.02", price: "3.02", id: 49416745582901 },
    { name: "4.03", price: "4.03", id: 49416745615669 },
    { name: "5.04", price: "5.04", id: 49416745681205 },
    { name: "6.05", price: "6.05", id: 49416745713973 },
    { name: "7.06", price: "7.06", id: 49416745746741 },
    { name: "8.07", price: "8.07", id: 49416745779509 },
    { name: "9.08", price: "9.08", id: 49416745812277 },
    { name: "10.09", price: "10.09", id: 49416745845045 },
    { name: "11.10", price: "11.10", id: 49416745877813 },
    { name: "12.11", price: "12.11", id: 49416745910581 },
    { name: "13.12", price: "13.12", id: 49416745943349 },
    { name: "14.13", price: "14.13", id: 49416745976117 },
    { name: "15.14", price: "15.14", id: 49416746008885 },
    { name: "16.15", price: "16.15", id: 49416746041653 },
    { name: "17.16", price: "17.16", id: 49416746074421 },
    { name: "18.17", price: "18.17", id: 49416746107189 },
    { name: "19.18", price: "19.18", id: 49416746139957 },
    { name: "20.19", price: "20.19", id: 49416746172725 },
    { name: "21.20", price: "21.20", id: 49416746205493 },
    { name: "22.21", price: "22.21", id: 49416746238261 },
    { name: "23.22", price: "23.22", id: 49416746271029 },
    { name: "24.23", price: "24.23", id: 49416746303797 },
    { name: "25.24", price: "25.24", id: 49416746336565 },
    { name: "26.25", price: "26.25", id: 49416746369333 },
    { name: "27.26", price: "27.26", id: 49416746369333 },
    { name: "28.27", price: "28.27", id: 49416746434869 },
    { name: "29.28", price: "29.28", id: 49416746467637 },
    { name: "30.29", price: "30.29", id: 49416746500405 },
    { name: "31.30", price: "31.30", id: 49416746533173 },
    { name: "32.31", price: "32.31", id: 49416746565941 },
    { name: "33.32", price: "33.32", id: 49416746598709 },
    { name: "34.33", price: "34.33", id: 49416746631477 },
    { name: "35.34", price: "35.34", id: 49416746664245 },
    { name: "36.35", price: "36.35", id: 49416746697013 },
    { name: "37.36", price: "37.36", id: 49416746729781 },
    { name: "38.37", price: "38.37", id: 49416746762549 },
    { name: "39.38", price: "39.38", id: 49416746795317 },
    { name: "40.39", price: "40.39", id: 49416746828085 },
    { name: "41.40", price: "41.40", id: 49416746860853 },
    { name: "42.41", price: "42.41", id: 49416746893621 },
    { name: "43.42", price: "43.42", id: 49416746926389 },
    { name: "44.43", price: "44.43", id: 49416746959157 },
    { name: "45.44", price: "45.44", id: 49416746991925 },
    { name: "46.45", price: "46.45", id: 49416747024693 },
    { name: "47.46", price: "47.46", id: 49416747090229 },
    { name: "48.47", price: "48.47", id: 49416747122997 },
    { name: "49.48", price: "49.48", id: 49416747188533 },
    { name: "50.49", price: "50.49", id: 49416747254069 },
    { name: "51.50", price: "51.50", id: 49416747319605 },
    { name: "52.51", price: "52.51", id: 49416747385141 },
    { name: "53.52", price: "53.52", id: 49416747483445 },
    { name: "54.53", price: "54.53", id: 49416747516213 },
    { name: "55.54", price: "55.54", id: 49416747614517 },
    { name: "56.55", price: "56.55", id: 49416747680053 },
    { name: "57.56", price: "57.56", id: 49416747745589 },
    { name: "58.57", price: "58.57", id: 49416747811125 },
    { name: "59.58", price: "59.58", id: 49416747876661 },
    { name: "60.59", price: "60.59", id: 49416747909429 },
    { name: "61.60", price: "61.60", id: 49416747974965 },
    { name: "62.61", price: "62.61", id: 49416748040501 },
    { name: "63.62", price: "63.62", id: 49416748106037 },
    { name: "64.63", price: "64.63", id: 49416748171573 },
    { name: "65.64", price: "65.64", id: 49416748204341 },
    { name: "66.65", price: "66.65", id: 49416748269877 },
    { name: "67.66", price: "67.66", id: 49416748335413 },
    { name: "68.67", price: "68.67", id: 49416748400949 },
    { name: "69.68", price: "69.68", id: 49416748433717 },
    { name: "70.69", price: "70.69", id: 49416748466485 },
    { name: "71.70", price: "71.70", id: 49416748499253 },
    { name: "72.71", price: "72.71", id: 49416748532021 },
    { name: "73.72", price: "73.72", id: 49416748564789 },
    { name: "74.73", price: "74.73", id: 49416748597557 },
    { name: "75.74", price: "75.74", id: 49416748630325 },
    { name: "76.75", price: "76.75", id: 49416748663093 },
    { name: "77.76", price: "77.76", id: 49416748695861 },
    { name: "78.77", price: "78.77", id: 49416748728629 },
    { name: "79.78", price: "79.78", id: 49416748761397 },
    { name: "80.79", price: "80.79", id: 49416748794165 },
    { name: "81.80", price: "81.80", id: 49416748826933 },
    { name: "82.81", price: "82.81", id: 49416748859701 },
    { name: "83.82", price: "83.82", id: 49416748892469 },
    { name: "84.83", price: "84.83", id: 49416748925237 },
    { name: "85.84", price: "85.84", id: 49416748958005 },
    { name: "86.85", price: "86.85", id: 49416748990773 },
    { name: "87.86", price: "87.86", id: 49416749023541 },
    { name: "88.87", price: "88.87", id: 49416749056309 },
    { name: "89.88", price: "89.88", id: 49416749089077 },
    { name: "90.89", price: "90.89", id: 49416749121845 },
    { name: "91.90", price: "91.90", id: 49416749154613 },
    { name: "92.91", price: "92.91", id: 49416749187381 },
    { name: "93.92", price: "93.92", id: 49416749220149 },
    { name: "94.93", price: "94.93", id: 49416749252917 },
    { name: "95.94", price: "95.94", id: 49416749285685 },
    { name: "96.95", price: "96.95", id: 49416749318453 },
    { name: "97.96", price: "97.96", id: 49416749351221 },
    { name: "98.97", price: "98.97", id: 49416749383989 },
    { name: "99.98", price: "99.98", id: 49416749416757 }
  ]
};

let config = document.getElementById("cart-config");

var ParcelProtection = {
  initRequestId: 0,

  Init: function () {
    var requestId = ++ParcelProtection.initRequestId;

    fetch("/cart.js")
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        if (requestId === ParcelProtection.initRequestId) {
          ParcelProtection.InitWithCart(cart);
        }
      });
  },

  InitWithCart: function (cart) {
    var cartTotal = ParcelProtection.getCartTotalInStoreCurrency(cart);
    var protectionStatus = ParcelProtection.getCookie("Protectionstatus");

    var productItems = cart.items.filter(function (item) {
      return !ParcelProtection.isProtectionItem(item);
    });

    var protectionItems = cart.items.filter(function (item) {
      return ParcelProtection.isProtectionItem(item);
    });

    if (productItems.length === 0 && protectionItems.length > 0) {
      ParcelProtection.showEmptyCartState();
      ParcelProtection.removeProtectionItems(protectionItems).then(function () {
        ParcelProtection.refreshCartView();
      });
      return;
    }

    if (
      protectionStatus === "true" &&
      productItems.length > 0 &&
      protectionItems.length > 0
    ) {
      ParcelProtection.syncProtectionVariant(cart);
    }

    var insuranceValue = 0;

    if (cartTotal > InsuranceData.threshold_price) {
      var selectedVariant = ParcelProtection.getClosestVariant(
        cartTotal,
        InsuranceData.variants
      );

      $("#insurancePrice,.template-cart #insurancePrice").html(
        theme.Helpers.formatMoney(
          Number(selectedVariant.price) * 100,
          config.money_format
        )
      );

      if (protectionStatus === "true") {
        insuranceValue = Number(selectedVariant.price);
      }
    } else {
      $("#insurancePrice,.template-cart #insurancePrice").html(
        theme.Helpers.formatMoney(
          InsuranceData.basic_price * 100,
          config.money_format
        )
      );

      if (protectionStatus === "true") {
        insuranceValue = InsuranceData.basic_price;
      }
    }

    $("#easy-protection, .template-cart #easy-protection").prop(
      "checked",
      protectionStatus === "true"
    );

    var displayedSubtotal = Math.abs(cartTotal + insuranceValue) * 100;

    $(".subtotal-price .js-cart-subtotal").html(
      theme.Helpers.formatMoney(displayedSubtotal, config.money_format)
    );
  },

  Checkproduct: function () {
    fetch("/cart.js")
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var productItems = cart.items.filter(function (item) {
          return !ParcelProtection.isProtectionItem(item);
        });

        var protectionItems = cart.items.filter(function (item) {
          return ParcelProtection.isProtectionItem(item);
        });

        if (productItems.length === 0 && protectionItems.length > 0) {
          ParcelProtection.showEmptyCartState();

          ParcelProtection.removeProtectionItems(protectionItems).then(function () {
            ParcelProtection.refreshCartView();
          });
        }
      });
  },

  isProtectionItem: function (item) {
    return (
      Number(item.product_id) === Number(InsuranceData.product_id) ||
      item.handle === "shipping-insurance"
    );
  },

  getCartTotalInStoreCurrency: function (cart) {
    var presentmentTotal = 0;

    cart.items.forEach(function (item) {
      if (!ParcelProtection.isProtectionItem(item)) {
        presentmentTotal += Number(item.final_line_price || 0);
      }
    });

    presentmentTotal = presentmentTotal / 100;

    var currencyRate = 1;

    if (
      window.Shopify &&
      Shopify.currency &&
      Shopify.currency.rate
    ) {
      currencyRate = parseFloat(Shopify.currency.rate);
    }

    if (!currencyRate || currencyRate <= 0) {
      currencyRate = 1;
    }

    return presentmentTotal / currencyRate;
  },

  getExpectedProtectionVariant: function (cart) {
    var cartTotal = ParcelProtection.getCartTotalInStoreCurrency(cart);

    if (cartTotal > InsuranceData.threshold_price) {
      return ParcelProtection.getClosestVariant(
        cartTotal,
        InsuranceData.variants
      ).id;
    }

    return InsuranceData.basic_variant;
  },

  syncProtectionVariant: function (cart) {
    var protectionItems = cart.items.filter(function (item) {
      return ParcelProtection.isProtectionItem(item);
    });

    if (protectionItems.length === 0) {
      return Promise.resolve();
    }

    var expectedVariant = Number(
      ParcelProtection.getExpectedProtectionVariant(cart)
    );

    var isCorrect =
      protectionItems.length === 1 &&
      Number(protectionItems[0].variant_id) === expectedVariant &&
      Number(protectionItems[0].quantity) === 1;

    if (isCorrect) {
      return Promise.resolve();
    }

    return ParcelProtection.removeProtectionItems(protectionItems)
      .then(function () {
        return fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            items: [
              {
                id: expectedVariant,
                quantity: 1
              }
            ]
          })
        });
      })
      .then(function () {
        ParcelProtection.refreshCartView();
      });
  },

  removeProtectionItems: function (items) {
    return items.reduce(function (promise, item) {
      return promise.then(function () {
        return fetch("/cart/change.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            id: item.key,
            quantity: 0
          })
        });
      });
    }, Promise.resolve());
  },

  refreshCartView: function () {
    var configElement = document.getElementById("cart-config");

    if (
      configElement &&
      Shopify.theme &&
      Shopify.theme.cart &&
      Shopify.theme.ajaxCart
    ) {
      var cartConfig = JSON.parse(configElement.innerHTML || "{}");

      Shopify.theme.cart.getCart().then(function (cart) {
        Shopify.theme.ajaxCart.updateView(cartConfig, cart);
      });
    }
  },

  showEmptyCartState: function () {
    $(".ajax-cart__cart-item.active-protections").remove();
    $(".js-cart-form").addClass("hide");
    $(".js-cart-empty").removeClass("hide");
    $(".js-cart-count").html("0");
    $("#cartdrawer-progress-bar").removeClass("enableProgressBar");
  },

  AddToCard: function (variant) {
    var formData = {
      items: [
        {
          id: variant,
          quantity: 1
        }
      ]
    };

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(formData)
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Unable to add Parcel Protection");
        }

        return response.json();
      })
      .then(function () {
        if (informationMessage()) {
          window.location.href = "/checkout";
        } else {
          $(".checkout-massage-wrapper").addClass("error");

          setTimeout(function () {
            $(".checkout-massage-wrapper").removeClass("error");
          }, 3000);

          alert("You must agree to the terms to check out");
        }
      })
      .catch(function () {
        alert("Unable to add Parcel Protection. Please refresh and try again.");
      });
  },

  getClosestVariant: function (total, variants) {
    var goal =
      (total * parseFloat(window.insurance.insurance_percentage)) / 100;

    return variants.reduce(function (previous, current) {
      return Math.abs(parseFloat(current.price) - goal) <
        Math.abs(parseFloat(previous.price) - goal)
        ? current
        : previous;
    });
  },

  CookieInit: function () {
    var protectionStatus = ParcelProtection.getCookie("Protectionstatus");

    if (protectionStatus == null) {
      document.cookie = "Protectionstatus=true";
    }
  },

  getCookie: function (name) {
    var cookieArr = document.cookie.split(";");

    for (var i = 0; i < cookieArr.length; i++) {
      var cookiePair = cookieArr[i].split("=");

      if (name === cookiePair[0].trim()) {
        return decodeURIComponent(cookiePair[1]);
      }
    }

    return null;
  }
};

$(document).on("click", ".ajax-cart__button-submit, [name='checkout'], #checkout, .cart__checkout-button", function (event) {
  event.stopPropagation();
  event.preventDefault();

  var informationMessageChecked = informationMessage();
  var easyStatus = ParcelProtection.getCookie("Protectionstatus");

  fetch("/cart.js")
    .then(function (response) {
      return response.json();
    })
    .then(function (cart) {
      var protectionItems = cart.items.filter(function (item) {
        return ParcelProtection.isProtectionItem(item);
      });

      var productItems = cart.items.filter(function (item) {
        return !ParcelProtection.isProtectionItem(item);
      });

      if (productItems.length === 0) {
        if (protectionItems.length > 0) {
          ParcelProtection.removeProtectionItems(protectionItems).then(function () {
            alert("Please add a product before checking out.");
            ParcelProtection.refreshCartView();
          });
        } else {
          alert("Please add a product before checking out.");
        }
        return;
      }

      if (easyStatus && easyStatus === "true") {
        var expectedVariant =
          ParcelProtection.getExpectedProtectionVariant(cart);

        if (protectionItems.length === 0) {
          ParcelProtection.AddToCard(expectedVariant);
          return;
        }

        ParcelProtection.syncProtectionVariant(cart)
          .then(function () {
            if (informationMessageChecked) {
              window.location.href = "/checkout";
            } else {
              $(".checkout-massage-wrapper").addClass("error");

              setTimeout(function () {
                $(".checkout-massage-wrapper").removeClass("error");
              }, 3000);

              alert("You must agree to the terms to check out");
            }
          })
          .catch(function () {
            alert(
              "We couldn't update Parcel Protection. Please refresh your cart and try again."
            );
          });
      } else {
        if (informationMessageChecked) {
          window.location.href = "/checkout";
        } else {
          $(".checkout-massage-wrapper").addClass("error");

          setTimeout(function () {
            $(".checkout-massage-wrapper").removeClass("error");
          }, 3000);

          alert("You must agree to the terms to check out");
        }
      }
    });
});

$(document).on("change", "#easy-protection", function () {
  var protectionCheckbox = $("#easy-protection");
  var description = $(".ins-description");

  if ($(this).prop("checked") === true) {
    description.text(window.insurance.protection_on_button_text);
    document.cookie = "Protectionstatus=true";
  } else {
    description.text(window.insurance.protection_off_button_text);
    document.cookie = "Protectionstatus=false";

    fetch("/cart.js")
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var protectionItems = cart.items.filter(function (item) {
          return ParcelProtection.isProtectionItem(item);
        });

        if (protectionItems.length > 0) {
          ParcelProtection.removeProtectionItems(protectionItems).then(function () {
            ParcelProtection.refreshCartView();
          });
        }
      });
  }

  ParcelProtection.Init();
});

function informationMessage() {
  var isChecked = $("#checkout-massage").is(":checked");
  return $("#checkout-massage").length !== 0 ? isChecked : true;
}

$(document).ready(function () {
  ParcelProtection.Checkproduct();
});
document.addEventListener("DOMContentLoaded", function () {
  ParcelProtection.Checkproduct();
});